import React, { useEffect, useState } from 'react'
import { getAllAnswerByEmpIdwithAdminToken, getCriteriaByModelIdwithadmintoken, getCriteriaByModelIdwithfilter, getCriteriaByModelIdwithfilterwithAdminToken } from '../../../services/api-services';
import { BLUEARROW_ICON, GREYARROW_ICON } from '../../../utills/image-constant';

const AdminTesteftbar = ({ pageName = "", onCriteriaSelect, selectedCriteriaId, CampaignData }) => {

    const [openMenus, setOpenMenus] = useState({});
    const [menuData, setMenuData] = useState([]);


    const getListOfQuestionbymodalDimension = async () => {
        try {
            const response = await getCriteriaByModelIdwithfilterwithAdminToken(
                CampaignData?.assessorCampaignResponse?.modelId,//modalid
                CampaignData?.assessorCampaignResponse?.companyAssessorId,//enmp id
                CampaignData?.assessorCampaignResponse?.campaignId
            );

            if (response?.data?.responseCode === 200) {
                const modelData = response.data.responseBody;
                const formattedMenu = buildMenuHierarchy(modelData);

                //  Determine whether model has only 1 dimension
                const modelHasOneDimension =
                    formattedMenu?.[0]?.subItems &&
                    formattedMenu[0].subItems.length === 1;

                //  Open all parents only if model has one dimension
                const defaultOpenMenus = {};
                if (modelHasOneDimension) {
                    const openAllParents = (items) => {
                        items.forEach((item) => {
                            if (item.subItems && item.subItems.length > 0) {
                                defaultOpenMenus[item.name] = true;
                                openAllParents(item.subItems);
                            }
                        });
                    };
                    openAllParents(formattedMenu);
                }

                setMenuData(formattedMenu);
                setOpenMenus(defaultOpenMenus);
            }
        } catch (err) {
            console.error("Error fetching model data:", err);
        }
    };

    useEffect(() => {
        getListOfQuestionbymodalDimension();
    }, []);

    const buildMenuHierarchy = (modelData) => {
        if (!modelData?.dimensionResponseList) return [];

        const validDimensions = modelData.dimensionResponseList
            .map((dimension) => {
                const validSubDimensions = (dimension.subDimensionResponseList || [])
                    .map((subDim) => {
                        const validCriteria = (subDim.criteriaResponseList || []).filter(
                            (criteria) => criteria?.criteriaShortLabel
                        );

                        if (validCriteria.length > 0) {
                            return {
                                name: subDim.subDimensionName,
                                level: "subDimension",
                                subPercentage: subDim.subPercentage ?? 0, // ✅ include subPercentage
                                subItems: validCriteria.map((criteria) => ({
                                    name: criteria.criteriaShortLabel,
                                    id: criteria.id,
                                    level: "criteria",
                                })),
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                if (validSubDimensions.length > 0) {
                    return {
                        name: dimension.dimensionName,
                        level: "dimension",
                        dimensionPercentage: dimension.dimensionPercentage ?? 0, // ✅ include dimensionPercentage
                        subItems: validSubDimensions,
                    };
                }
                return null;
            })
            .filter(Boolean);

        if (validDimensions.length > 0) {
            return [
                {
                    name: modelData.modelName,
                    level: "model",
                    subItems: validDimensions,
                },
            ];
        }
        return [];
    };


    //  Recursive sidebar rendering
    //  Recursive sidebar rendering
    const renderMenu = (items, level = 0) => (
        <ul className={`menu-level ${level === 3 ? "dotted-level" : ""}`}>
            {items.map((item, idx) => {
                const isOpen = openMenus[item.name];
                const hasChildren = item.subItems && item.subItems.length > 0;
                const isCriteria = item.level === "criteria";
                const isActive = selectedCriteriaId === item.id;

                // Determine percentage for dimension or subDimension
                const percentage =
                    item.level === "dimension"
                        ? item.dimensionPercentage || 0
                        : item.level === "subDimension"
                            ? item.subPercentage || 0
                            : 0;

                return (
                    <li key={idx} className="menu-li position-relative">
                        {/* Active criteria indicator */}
                        {isCriteria && isActive && (
                            <span className="square-indicator-on-line"></span>
                        )}

                        <div
                            className={`menu-item d-flex align-items-center justify-content-between 
                    ${isCriteria ? "criteria-item" : ""} 
                    ${isActive ? "active-criteria" : ""}`}
                            onClick={() => {
                                if (isCriteria) {
                                    if (pageName === "previewleftbar") {
                                        const el = document.getElementById(`question-${item.id}`);
                                        if (el) {
                                            el.scrollIntoView({ behavior: "smooth", block: "start" });

                                            // 🔥 Highlight trigger (send id to parent)
                                            window.dispatchEvent(new CustomEvent("highlight-question", { detail: item.id }));
                                        }
                                    }
                                    onCriteriaSelect?.(item.id);

                                } else if (hasChildren) {
                                    setOpenMenus((prev) => ({
                                        ...prev,
                                        [item.name]: !prev[item.name],
                                    }));
                                }
                            }}
                        >
                            <div className="d-flex align-items-center">
                                {/* Circle Indicator for Dimension & SubDimension */}
                                {(item.level === "dimension" || item.level === "subDimension") && (
                                    <div className="circle-indicator-wrapper" title={`${percentage}%`}>
                                        <div
                                            className="circle-indicator"
                                            style={{
                                                background: `conic-gradient(#007bff ${percentage}%, #fff 0)`,
                                            }}
                                        ></div>
                                    </div>
                                )}

                                {/* Menu Text */}
                                <span
                                    className={`menu-text 
        ${item.level === "model" ? "model-title" : ""} 
        ${item.level === "dimension" ? "dimension-text" : ""} 
        ${item.level === "subDimension" ? "subDimension-text" : ""}`}
                                >
                                    {item.name}
                                </span>
                            </div>

                            {/* Expand/Collapse Arrow */}
                            {hasChildren && (
                                <img
                                    className="arrow"
                                    src={isOpen ? BLUEARROW_ICON : GREYARROW_ICON}
                                    alt="arrow"
                                />
                            )}
                        </div>

                        {/* Recursive Rendering */}
                        {hasChildren && isOpen && renderMenu(item.subItems, level + 1)}
                    </li>
                );
            })}
        </ul>
    );
    return (
        <div className={`Question_left_bar ${pageName == "previewleftbar" ? "preview-left-bar" : ""}`}>
            {menuData.length > 0 ? renderMenu(menuData) : <p>No data found</p>}
        </div>
    )
}

export default AdminTesteftbar;
